import React from "react";
import {withRouter} from 'react-router-dom';


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import queryString from 'qs'
import axios from "axios";

import logo from "assets/img/cirrusLogo.jpg";
import { getSearchString } from "../../assets/helpers/urlHelper";
import {getApiHeaders} from "../../assets/helpers/apiHelper";

import { API_ROOT } from 'api-config';

class PreLoginHeader extends React.Component {
  constructor(props) {
    super(props);
    const searchString = getSearchString(this.props.location.search)
    const values = queryString.parse(searchString)
    var providerId = ''
    if (values.provider && !isNaN(values.provider)) {
      providerId = values.provider
    }
    this._isMounted = false;
    this.state = {
      logo: "",
      altLogo: "",
      providerName: "",
      providerId: providerId
    };

  }

  componentDidMount(){
    this._isMounted = true;
    this.getLogo()
  }

  getLogo() {
    if (this.state.providerId) {
      axios.get(`${API_ROOT}/providerSearch/?providerId=`+this.state.providerId + `&includeInactive=1&returnHidden=1`, {headers: getApiHeaders()})
        .then(res => this.setLogo({responseMessage: res.data[0]}));
    } else {
      this.setState({
        logo: logo,
        altLogo: "Cirrus Dental logo"
      })
    }
  }

  setLogo(res) {
    if (res.responseMessage !== undefined) {
      var altLogo = res.responseMessage.name + " logo"
      this.setState({
        altLogo: altLogo,
        logo: res.responseMessage.logo,
        providerName: res.responseMessage.name
      })
    }
  }

  render() {
    return (
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardBody>
              <div style={{ textAlign: 'center' }}>
                <h3 style={this.state.logo ? { display: 'none' } : {}}>{this.state.providerName}</h3>
                <img src={this.state.logo} alt={this.state.altLogo} style={this.state.logo ? {} : { display: 'none' }}/>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }

}


export default withRouter(PreLoginHeader);